import script from "./VitaSideNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaSideNav.vue?vue&type=script&setup=true&lang=ts"

import "./VitaSideNav.vue?vue&type=style&index=0&id=11e6e9c5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11e6e9c5"]])

export default __exports__